import quickFetch from 'quick-fetch';

// Helper to generate a quick fetch name for default pinned view
export const generateDefaultPinnedViewQuickFetchName = ({
  objectTypeId,
  namespace,
  viewId,
}: {
  objectTypeId: string;
  namespace: string;
  viewId?: string;
}) => {
  return `DEFAULT_PINNED_VIEW_QUICK_FETCH_${namespace}_${objectTypeId}${
    viewId ? `_${viewId}` : ''
  }`;
};

export const quickFetchDefaultPinnedView = ({
  objectTypeId,
  namespace,
  viewId,
}: {
  objectTypeId: string;
  namespace: string;
  viewId?: string;
}) => {
  return new Promise((resolve, reject) => {
    quickFetch.makeEarlyRequest(
      generateDefaultPinnedViewQuickFetchName({
        objectTypeId,
        namespace,
        viewId,
      }),
      {
        url: quickFetch.getApiUrl(
          `/sales/v4/views/default-view/${objectTypeId}?namespace=${namespace}${
            viewId ? `&viewId=${viewId}` : ''
          }`,
          true
        ),
        timeout: 14000,
        dataType: 'json',
        contentType: 'application/json',
        type: 'GET',
        onError: (error) => {
          reject(error);
        },
        whenFinished: (response) => {
          resolve(response);
        },
      }
    );
  });
};
